<template>
  <router-view />
</template>

<script>
export default {
  name: "DirectoryBase",
};
</script>

<style></style>
